"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _uuid = require("uuid");
var _icon = _interopRequireDefault(require("../icon"));
var _Breadcrumb = _interopRequireDefault(require("./Breadcrumb.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ICON_SIZE = 12;
var Breadcrumb = function Breadcrumb(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_Breadcrumb["default"], {
    className: "breadcrumb"
  }, R.flatten(children).map(function (child) {
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: child.key || (0, _uuid.v4)()
    }, /*#__PURE__*/_react["default"].createElement("li", null, child), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
      icon: "ion-chevron-right",
      size: ICON_SIZE
    }));
  }));
};
Breadcrumb.propTypes = {
  children: _propTypes["default"].node.isRequired
};
var _default = exports["default"] = Breadcrumb;